import React from 'react';
import { Lock } from 'lucide-react';
export function FinalCTASection() {
  return <section className="relative w-full py-16 px-4 bg-navy overflow-hidden" data-id="element-81">
      {/* Radial golden glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-82"></div>

      <div className="relative z-10 max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-83">
        <p className="text-warm-gold text-sm tracking-[0.2em] uppercase mb-8 font-medium" data-id="element-84">
          You've read this far for a reason.
        </p>

        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-cream leading-tight mb-6" data-id="element-85">
          You've Done The Hard Part. You Showed Up. You Did The Work.
        </h2>

        <p className="font-serif text-2xl md:text-3xl lg:text-4xl text-warm-gold italic leading-tight mb-10" data-id="element-86">
          Now Let's Clear The Signal So It Finally Reaches Where It Counts.
        </p>

        <p className="text-lg md:text-xl text-cream/80 mb-10 font-light" data-id="element-87">
          7 days. 15 minutes a day. One audio track. That's all it takes.
        </p>

        {/* Price block */}
        <div className="flex items-baseline justify-center space-x-4 mb-8" data-id="element-88">
          <span className="text-cream/40 line-through text-2xl md:text-3xl font-light" data-id="element-89">
            $305
          </span>
          <span className="text-cream text-5xl md:text-6xl font-serif font-bold" data-id="element-90">
            $6.37
          </span>
        </div>

        <a href="https://pay.hotmart.com/Q105372393V?checkoutMode=10" onClick={() => {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'AddToCart');
        }
      }} className="w-full md:w-auto inline-flex items-center justify-center px-10 py-6 bg-cta-red text-white font-bold text-xl md:text-2xl rounded-full animate-heartbeat hover:bg-red-700 transition-colors duration-300 mb-6" data-id="element-91">
          Clear My Frequency Now → $6.37
        </a>

        <div className="flex items-center justify-center space-x-2 text-warm-gold font-medium text-xs md:text-sm" data-id="element-92">
          <Lock className="w-4 h-4" data-id="element-93" />
          <span data-id="element-94">
            Secure Checkout | Instant Digital Delivery | 7-Day Money Back
            Guarantee
          </span>
        </div>
      </div>
    </section>;
}